class DynamicLinks {
    constructor() {
        const links= document.querySelectorAll('a[href="#newsletter"]');
       
        links.forEach(function (link) {
            link.dataset.toggle = 'modal'
            link.dataset.target = '#form-modal-newsletter'
        });
        const megaMenuLinks = document.querySelectorAll('a.main-menu__item__link[href="#"]');
        megaMenuLinks.forEach(function (link) {
            link.addEventListener("click",function(e){
                e.preventDefault();
            });
        });
        
        const footerNewsInput = document.querySelector('#footer-input-email');
        
        footerNewsInput.addEventListener("keyup", (e) => {
           
            if (e.key === 'Enter' || e.keyCode === 13) {
                e.preventDefault()
            }
            else {
                const mcEmails = document.querySelectorAll('.mc-email');
                let v = e.target.value;
                mcEmails.forEach(function (inp) {
                    inp.value = v;
                })
            }
        })
        

        

    }
}

export default new DynamicLinks;